import FoxService from '@/services/FoxService';

const foxes = {
    state: {
        locations: []
    },
    mutations: {
        ['SET_FOX_LOCATIONS'] (state, path) {
            state.locations = path;
        }
    },
    actions: {
        ['RETRIEVE_FOX_LOCATIONS'] ({commit}) {
            FoxService.get('alpha', path => {
                commit('SET_FOX_LOCATIONS', path);
            });
        },
        ['ADD_FOX_LOCATION'] ({commit}, payload) {
            FoxService.add(payload);
        },
        ['REMOVE_FOX_LOCATION'] ({commit}, payload) {
            FoxService.remove(payload);
        }
    },
    getters: {
        alpha: state => {
            return state.locations.filter((loc) => { return loc.fox === "alpha" });
        },
        bravo: state => {
            return state.locations.filter((loc) => { return loc.fox === "bravo" });
        },
        charlie: state => {
            return state.locations.filter((loc) => { return loc.fox === "charlie" });
        },
        delta: state => {
            return state.locations.filter((loc) => { return loc.fox === "delta" });
        },
        echo: state => {
            return state.locations.filter((loc) => { return loc.fox === "echo" });
        },
        foxtrot: state => {
            return state.locations.filter((loc) => { return loc.fox === "foxtrot" });
        },
        hunt_alpha: (state,getters) => {
            var fox = getters.alpha.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_bravo: (state,getters) => {
            var fox = getters.bravo.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_charlie: (state,getters) => {
            var fox = getters.charlie.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_delta: (state,getters) => {
            var fox = getters.delta.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_echo: (state,getters) => {
            var fox = getters.echo.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        },
        hunt_foxtrot: (state,getters) => {
            var fox = getters.foxtrot.find((loc) => {
                return loc.isHunt == true;
            });
            return fox;
        }
    }
};

export default foxes;


// WEBPACK FOOTER //
// ./src/store/modules/foxes.js